import { generatePath } from 'react-router-dom'

import { ChooseSportType } from 'components/ChooseSport/ChooseSport'

export enum MODAL_ROUTE_PATH {
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  SEARCH_SLOTS = '/search-slots',
  FORGOT_PASSWORD = '/forgot-password',
  PAYMENT_TRANSFER_DESCRIPTION = '/payment-transfer-comment/:transferId',
  SIGN_UP_WITH_PROMOCODE = '/sign-up/:promocode',
  DEPOSIT = '/deposit',
  DEPOSIT_PAYMENT_SYSTEM = '/deposit/:paymentSystem',
  WITHDRAWAL = '/withdrawal',
  RESET_PASSWORD = '/reset-password/:uid/:token',
  WHEEL_GAME = '/wheel-game',
  WHEEL_GAME_HISTORY = '/wheel-game-history',
  RESEND_EMAIL = '/resend-email',
  VERIFY_EMAIL = '/verify-email',
  EMAIL_SENT = '/email-sent',
  CONFIRM_ACTIVATE_BONUS = '/confirm-activate-bonus/:bonusId',
  PROFILE_DESKTOP = '/profile-desktop/:tab',
  BET_DETAILS = '/bet-details',
  CHANGE_PASSWORD = '/change-password',
  CHOOSE_SPORT = '/choose-sport/:type',

  CHECK_YOUR_EMAIL = '/check-your-email',
  VERIFY_EMAIL_SUCCESS = '/verify-email',
  RESET_PASSWORD_CONFIRM = '/emails/verify/password/confirm/:token',

  DOCUMENT_UPLOAD = '/document-upload',
  LOGOUT = '/logout',
}

export const MODAL_ROUTE_URLS = {
  SIGN_IN: () => generatePath(MODAL_ROUTE_PATH.SIGN_IN),
  SIGN_UP: () => generatePath(MODAL_ROUTE_PATH.SIGN_UP),
  VERIFY_EMAIL: () => generatePath(MODAL_ROUTE_PATH.VERIFY_EMAIL),
  EMAIL_SENT: () => generatePath(MODAL_ROUTE_PATH.EMAIL_SENT),
  SEARCH_SLOTS: () => generatePath(MODAL_ROUTE_PATH.SEARCH_SLOTS),
  FORGOT_PASSWORD: () => generatePath(MODAL_ROUTE_PATH.FORGOT_PASSWORD),
  SIGN_UP_WITH_PROMOCODE: (promocode: string) => generatePath(MODAL_ROUTE_PATH.SIGN_UP_WITH_PROMOCODE, { promocode }),
  DEPOSIT_PAYMENT_SYSTEM: (paymentSystem: string) =>
    generatePath(MODAL_ROUTE_PATH.DEPOSIT_PAYMENT_SYSTEM, { paymentSystem }),
  DEPOSIT: () => generatePath(MODAL_ROUTE_PATH.DEPOSIT),
  WITHDRAWAL: () => generatePath(MODAL_ROUTE_PATH.WITHDRAWAL),
  RESET_PASSWORD: (uid: string, token: string) => generatePath(MODAL_ROUTE_PATH.RESET_PASSWORD, { uid, token }),
  WHEEL_GAME: () => generatePath(MODAL_ROUTE_PATH.WHEEL_GAME),
  WHEEL_GAME_HISTORY: () => generatePath(MODAL_ROUTE_PATH.WHEEL_GAME_HISTORY),
  RESEND_EMAIL: () => generatePath(MODAL_ROUTE_PATH.RESEND_EMAIL),
  CONFIRM_ACTIVATE_BONUS: (bonusId: string) => generatePath(MODAL_ROUTE_PATH.CONFIRM_ACTIVATE_BONUS, { bonusId }),
  PROFILE_DESKTOP: (tab: string) => generatePath(MODAL_ROUTE_PATH.PROFILE_DESKTOP, { tab }),
  BET_DETAILS: () => generatePath(MODAL_ROUTE_PATH.BET_DETAILS),
  CHANGE_PASSWORD: () => generatePath(MODAL_ROUTE_PATH.CHANGE_PASSWORD),
  CHOOSE_SPORT: (type: ChooseSportType) => generatePath(MODAL_ROUTE_PATH.CHOOSE_SPORT, { type }),

  CHECK_YOUR_EMAIL: () => generatePath(MODAL_ROUTE_PATH.CHECK_YOUR_EMAIL),
  VERIFY_EMAIL_SUCCESS: () => generatePath(MODAL_ROUTE_PATH.VERIFY_EMAIL_SUCCESS),
  RESET_PASSWORD_CONFIRM: (token: string) => generatePath(MODAL_ROUTE_PATH.RESET_PASSWORD_CONFIRM, { token }),

  DOCUMENT_UPLOAD: () => generatePath(MODAL_ROUTE_PATH.DOCUMENT_UPLOAD),
  LOGOUT: () => generatePath(MODAL_ROUTE_PATH.LOGOUT),
}
